<template>
  <v-row align="center" justify="center">
    <v-col class="text-center pt-0 px-5" cols="12" md="11">
      <v-col class="pt-0" v-if="getProcesos.length > 0">
        <!-- Section *Donwload Links* -->
        <Download />
        <!-- Table  -->
        <v-data-table
          :headers="headers"
          :items="getProcesos"
          hide-default-footer
          :items-per-page="getPaginacionProcesos.registrosPagina"
          class="elevation-1 caption"
          :loading="getStatus.loading"
          loading-text="'Cargando... Por favor espere'"
          ref="table"
        >
          <template v-slot:item.esPrivado="{ item }">
            <div @dblclick="infoSupport(item)">
              <v-simple-checkbox
                class="text-center"
                :disabled="getVisited ? false : true"
                color="blue"
                :value="getVisited.includes(item.idProceso)"
              ></v-simple-checkbox>
            </div>
          </template>
          <template v-slot:item.llaveProceso="{ item }">
            <v-tooltip top v-if="!item.esPrivado">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  class="blue--text"
                  @click="$emit('go-to-details', { id: item.idProceso })"
                  v-bind="attrs"
                  v-on="on"
                >{{ item.llaveProceso }}</v-btn>
              </template>
              <span>Mostrar Detalles del Proceso</span>
            </v-tooltip>
            <p v-else class="mb-0">{{ item.llaveProceso }}</p>
          </template>
          <template v-slot:item.fechaProceso="{ item }">
            <div :style="$vuetify.breakpoint.xs ? '' : ''">
              {{ item.fechaProceso }}
              <br />
              <v-tooltip bottom v-if="!item.esPrivado">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="item.fechaUltimaActuacion"
                    text
                    class="blue--text"
                    @click="$emit('go-to-details', { id: item.idProceso, tab: 3 })"
                    v-bind="attrs"
                    v-on="on"
                  >{{ item.fechaUltimaActuacion }}</v-btn>
                </template>
                <span>Mostrar Listado de Actuaciones</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.despacho="{ item }">
            <div class="text-left pl-0">{{ item.despacho }} ({{ item.departamento }})</div>
          </template>
          <template v-slot:item.sujetosProcesales="{ item }">
            <div class="text-left" v-html="item.sujetosProcesales"></div>
          </template>
          <template v-slot:item.idConexion="{ item }">
            <template v-if="getProcesos.length > 1">
              <v-icon small v-if="item.idConexion === 320">fas fa-hdd</v-icon>
              <v-icon small v-else-if="item.idConexion !== 320">fas fa-bars</v-icon>
            </template>
          </template>
          <template v-if="getStatus.loading" v-slot:progress>
            <v-progress-linear color="primary" :height="3" indeterminate></v-progress-linear>
          </template>
          <template v-if="getStatus.loading" v-slot:footer>
            <v-progress-linear color="primary" :height="3" indeterminate></v-progress-linear>
          </template>
        </v-data-table>
        <div class="mt-8 text-center">
          <Pagination />
        </div>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
//Components
import Pagination from "@/components/process/Pagination";
import Download from "@/components/Download";
import { mapGetters } from "vuex";

export default {
  components: {
    Pagination,
    Download,
  },
  computed: {
    ...mapGetters("process", [
      "getProcesos",
      "getPaginaActualProcesos",
      "getPaginacionProcesos",
      "getDetails",
      "getStatus",
      "getVisited",
      "getDuplicated",
    ]),
  },
  data: () => ({
    sowTable: false,
    isPaginacion: false,
    ready: "",
    replaceTitle: "Demandante, Demandado, Departamento",
    result: [],
    headers: [
      {
        text: "Consultado",
        value: "esPrivado",
        sortable: false,
        class: "grey--text text--darken-3 font-weight-bold ",
      },
      {
        text: "Número de Radicación",
        value: "llaveProceso",
        class: "grey--text text--darken-3 body-1 font-weight-bold",
        align: "center",
        sortable: false,
      },
      {
        text: "Fecha de Radicación y última actuación",
        value: "fechaProceso",
        class: "grey--text text--darken-3 body-1 font-weight-bold",
        align: "center",
        sortable: false,
      },
      {
        text: "Despacho y Departamento",
        value: "despacho",
        class: "grey--text text--darken-3 body-1 font-weight-bold",
        align: "center",
        sortable: false,
      },
      {
        text: "Sujetos Procesales",
        value: "sujetosProcesales",
        class: "grey--text text--darken-3 body-1 font-weight-bold",
        align: "center",
        sortable: false,
      },
      {
        text: "",
        value: "idConexion",
        align: "center",
        sortable: false,
        width: 10,
      },
    ],
    nameRules: [
      (v) => !!v || "Número de Radicación requerido",
      (v) =>
        (v && v.length == 23) ||
        "El número de Radicación ha de ser de 23 dígitos",
    ],
    message:
      "La consulta no generó resultados, por favor revisar las opciones ingresadas e intentarlo nuevamente",
  }),
  methods: {
    goToDetails(id) {
      this.$router.push(`/details-process/${id}`, async () => {
        await this.$store.dispatch("process/details", { id: id });
      });
    },
    async goToDetailsDate(id) {
      await this.$store.dispatch("process/details", { id: id, tab: 3 });
      this.$router.push(`/details-process/${id}`);
    },
    infoSupport(item) {
      confirm(
        "IdConexion = " +
          item.idConexion +
          ", " +
          "IdProceso = " +
          item.idProceso
      );
    },
  },
  watch: {
    getProcesos(val) {
      if (val && val.length > 0) {
        this.$store.dispatch(
          "process/setUrlAyuda",
          "/manual/resultadosConsulta.html#listado-de-resultados"
        );
      }
    },
  },
  mounted() {},
};
</script>
